var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.36 0 6.23 31.9l-.03.09 10.1-7.18.02-.02L26.57 32l-3.6-12.07v-.02l9.98-7.96h-12.5L16.36 0Zm.49 8.5-1.58-.49.58-1.79.02.02 1.53.47-.54 1.8h-.01Zm-2.75 3.33v-.03l.51-1.76 1.61.52-.01.04-.54 1.67v.02l-1.57-.46Zm-1.25 3.8v-.02l.57-1.72 1.55.51v.03l-.53 1.7v.02l-1.6-.51Zm-1.22 3.87-.02-.01.58-1.72.01-.02 1.56.51v.03l-.55 1.72-1.58-.5Zm-1.2 3.87h-.02l.57-1.75H11l1.49.5-.5 1.69v.02l-1.56-.46Zm.32 4.3-1.58-.53.56-1.7v-.03l1.58.54v.06l-.53 1.68-.03-.02Zm.03-15.71H0l8.83 7.17v-.02l2.27-7.15h-.32Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1debea5904228d40a5b2d4bac741daff.svg";
export { ForwardRef as ReactComponent };